/**
 * OrderRequest (Faza 3D) — xodim yuborgan buyurtma sxemalari.
 *
 * XODIM kassada skaner qilib mahsulot yig'adi → "Yuborish" → PENDING buyurtma.
 * EGASI/ADMIN "Buyurtmalar"da ko'rib qabul qiladi → eganing kassasiga yuklanadi.
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
// ─── Buyurtma elementi (snapshot) ─────────────────────────────────
export const orderRequestItemSchema = z.object({
    productId: uuidSchema,
    variantIndex: z.number().int().min(0).nullable().optional(),
    quantity: z.number().int().min(1, 'Soni 1 dan kam emas').max(100_000),
    name: z.string().max(200),
    sku: z.string().max(50).nullable().optional(),
    unitPrice: z.number().min(0),
});
// ─── Create (XODIM yuboradi) ──────────────────────────────────────
export const createOrderRequestSchema = z.object({
    items: z.array(orderRequestItemSchema).min(1, 'Kamida 1 mahsulot kerak').max(500),
    note: z.string().trim().max(500).nullable().optional(),
});
//# sourceMappingURL=order-request.schema.js.map